import React from 'react';

import { isRoleAdmin, isRoleCustomer } from 'src/utils/check-user-is-admin';
import Page403 from 'src/pages/403';

export default function CustomerGuard({ children }: { children: React.ReactNode }) {
  return isRoleAdmin() || isRoleCustomer() ? <>{children}</> : <Page403 />;
}
